// src/modules/app-views/_apps/appmulti/coupons/pages/Init/components/tableColumns/operatorColumn.js
import translateX from 'utils/translateX';

function operatorColumn(buildColumnProps, options = {}) {
  const {
    key = 'operator',
    title = 'operator',
    dataIndex = '__operator',
    width = 200,
    columnProps = {},
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    ...(width && { width }),
    ...buildColumnProps(dataIndex, columnProps),
    render: (_, r) => {
      const name = r?.__operator?.name || r?.__operator?.fullName;
      if (!name) return <span className="text-muted">—</span>;
      return <span>{name}</span>;
    },
  };
}

export default operatorColumn;
